import { AgroforestryRoot } from './Agroforestry.root';

export const agroforestry = {
    Component: AgroforestryRoot,
};
